export const locale = {
    lang: 'fr',
    data: {
        PROJECTS_BOARD_NEW_DIALOG_CREATE_BOARD: 'Créer un tableau',
        PROJECTS_BOARD_NEW_DIALOG_GENERAL: 'Général',
        PROJECTS_BOARD_NEW_DIALOG_MEMBERS: 'Membres',
    }
};
